// removed by extract-text-webpack-plugin
module.exports = {"Education":"Education__Education___2Jylt","EducationHeader":"Education__EducationHeader___3eSm8"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/Resume/Education/Education.css
// module id = 40
// module chunks = 0